module.exports = __webpack_public_path__ + "static/media/innovation.6b4e3f9f.png";